import { render } from "./InstallationEdit.vue?vue&type=template&id=73c1220a&scoped=true"
import script from "./InstallationEdit.vue?vue&type=script&lang=js"
export * from "./InstallationEdit.vue?vue&type=script&lang=js"

import "./InstallationEdit.vue?vue&type=style&index=0&id=73c1220a&scoped=true&lang=css"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c1220a"]])

export default __exports__